module.exports = __webpack_public_path__ + "img/non-empty.19e70c68.svg";